module.exports = __webpack_public_path__ + "img/2.c6a71519.png";